import React from "react";

export const Notification = () => {
  return <div>Notification</div>;
};

export default Notification;
